module.exports = __webpack_public_path__ + "img/dark-header-1.e683e3a8.png";